import ko from 'knockout';
import { BidLandscapeBaseViewModel } from '../base-viewmodel';

export class KeywordBidLandscapeViewModel extends BidLandscapeBaseViewModel {
  constructor({
    parentItem,
    parentView,
    i18n,
    entityType,
    inSimpleMode,
    dataToShow,
  }) {
    super({
      parentItem, parentView, entityType, i18n, inSimpleMode, dataToShow,
    });
    this.tableBidText = ko.computed(() => i18n.getString('BidLandscape_kpiMaxCpC'));
  }
}
